import reduxstates from '../../../store/reduxstates/states'
// Actions
// ------------------------------------

export const resetStates = () => {
  return (dispatch) => {
    dispatch({
      type    : reduxstates.customerorderdetails,
      payload : {}
    })
    dispatch({
      type    : reduxstates.logincredentials,
      payload : {}
    })
    dispatch({
      type    : reduxstates.processingmodal,
      payload : {}
    })
  }
}



// WEBPACK FOOTER //
// ./src/layouts/skin/header/logout.js